









































































import Vue from "vue";
import SpotifyWebApi from "spotify-web-api-js";
import CenterLayout from "@/components/CenterLayout.vue";
import { StoreActions } from "@/structures/store";
import { spotifyCredentials } from "@/globalVariables";
import {
    SpotifyRefreshTokenResponse,
    RepeatState,
    CurrentlyPlayingObjectWithExtras,
} from "@/structures/spotifyApi";
import {
    requestPermission,
    showNotification,
    defaultEvents,
} from "@/notifications";
const PlaybackController = () => import("@/components/PlaybackController.vue");
const NoPlayback = () => import("@/components/NoPlayback.vue");
const Volume = () => import("@/components/dialogs/Volume.vue");
const DeviceSwitcher = () => import("@/components/dialogs/DeviceSwitcher.vue");

let spotify = new SpotifyWebApi();

export default Vue.extend({
    components: {
        CenterLayout,
        PlaybackController,
        NoPlayback,
        Volume,
        DeviceSwitcher,
    },
    data() {
        return {
            currentlyPlaying: {} as CurrentlyPlayingObjectWithExtras | null,

            trackName: null as string | null,
            trackSaved: false,

            // eslint-disable-next-line no-undef
            devices: [] as SpotifyApi.UserDevice[],

            refreshInterval: null as number | null,
            verboseMode: this.$route.query.verbose === "true",

            dialogs: {
                notification:
                    Notification.permission === "default" &&
                    localStorage.getItem("trackChangeNotifications") === null &&
                    this.$store.state.accessToken,
                volume: false,
                deviceSwitcher: false,
            },
        };
    },
    computed: {
        artists(): string {
            if (this.currentlyPlaying && this.currentlyPlaying.item?.artists) {
                return this.currentlyPlaying.item.artists
                    .map((artist) => artist.name)
                    .join(", ");
            } else {
                return "No artists found";
            }
        },
        progress(): string {
            if (this.currentlyPlaying && this.currentlyPlaying.progress_ms) {
                return this.convertMillisecondsToMinSec(
                    this.currentlyPlaying.progress_ms
                );
            } else {
                return "--:--";
            }
        },
        duration(): string {
            if (this.currentlyPlaying && this.currentlyPlaying.item) {
                return this.convertMillisecondsToMinSec(
                    this.currentlyPlaying.item?.duration_ms
                );
            } else {
                return "--:--";
            }
        },
    },
    mounted() {
        if (!this.$store.state.accessToken) {
            this.$router.push({ name: "Authorization" });
        } else {
            spotify.setAccessToken(this.$store.state.accessToken);

            this.refresh();
            this.refreshInterval = setInterval(this.refresh, 1000);
        }
    },
    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    },
    methods: {
        setNotificationsState(enableNotifications: boolean): void {
            this.dialogs.notification = false;

            switch (enableNotifications) {
                case true:
                    requestPermission();
                    localStorage.setItem("trackChangeNotifications", "true");
                    break;
                case false:
                    localStorage.setItem("trackChangeNotifications", "false");
                    break;
            }
        },
        setDevices(deviceId: string): void {
            spotify.transferMyPlayback([deviceId]);
        },
        openDeviceSwitcher(): void {
            spotify
                .getMyDevices()
                .then((response) => {
                    this.devices = response.devices;
                    this.dialogs.deviceSwitcher = true;
                })
                .catch((error) => {
                    try {
                        let json = JSON.parse(error.response);
                        if (json.status === 401) {
                            this.getNewTokens();
                        }
                    } catch {
                        console.error(error);
                    }
                });
        },
        setVolume(volume: number): void {
            spotify.setVolume(volume);
        },
        openVolumeDialog(): void {
            this.dialogs.volume = true;
        },
        toggleRepeat(): void {
            if (this.currentlyPlaying) {
                let newRepeatState = null as RepeatState | null;
                switch (this.currentlyPlaying.repeat_state) {
                    case "off":
                        newRepeatState = RepeatState.context;
                        break;
                    case "context":
                        newRepeatState = RepeatState.track;
                        break;
                    case "track":
                        newRepeatState = RepeatState.off;
                        break;
                }

                if (newRepeatState !== null) {
                    spotify.setRepeat(newRepeatState);
                }
            }
        },
        toggleShuffle(): void {
            if (this.currentlyPlaying) {
                spotify.setShuffle(!this.currentlyPlaying.shuffle_state);
            }
        },
        saveUnsave(): void {
            if (this.currentlyPlaying?.item) {
                let trackIds = [this.currentlyPlaying.item.id];

                if (this.trackSaved) {
                    spotify.removeFromMySavedTracks(trackIds);
                } else {
                    spotify.addToMySavedTracks(trackIds);
                }
            }
        },
        playpause(): void {
            if (this.currentlyPlaying?.is_playing) {
                spotify.pause();
            } else {
                spotify.play();
            }
        },
        nextTrack(): void {
            spotify.skipToNext();
        },
        previousTrack(): void {
            spotify.skipToPrevious();
        },
        getCurrentPlayback(): void {
            spotify
                .getMyCurrentPlaybackState()
                .then((state) => {
                    this.currentlyPlaying = state;
                    if (this.verboseMode) console.debug(state);

                    if (state.item) {
                        spotify
                            .containsMySavedTracks([state.item.id])
                            .then((response) => (this.trackSaved = response[0]))
                            .catch((error) => {
                                let json = JSON.parse(error.response);
                                if (json.status === 401) {
                                    this.getNewTokens();
                                }
                            });

                        if (
                            this.trackName !== null &&
                            state.item.name !== this.trackName &&
                            Notification.permission === "granted" &&
                            localStorage.getItem("trackChangeNotifications") ===
                                "true"
                        ) {
                            if (this.verboseMode)
                                console.info(
                                    `${state.item.name} (${this.artists})`
                                );
                            showNotification(
                                state.item.name,
                                {
                                    body: this.artists,
                                    icon: state.item.album.images[0].url,
                                    image: state.item.album.images[0].url,
                                    tag: "track-change",
                                },
                                true,
                                defaultEvents
                            );
                        } else if (
                            localStorage.getItem("trackChangeNotifications") ===
                                "true" &&
                            Notification.permission !== "granted"
                        ) {
                            switch (Notification.permission) {
                                case "default":
                                    console.info(
                                        "Notification permission has not yet been granted. Enable notifications to continue."
                                    );
                                    requestPermission();
                                    break;
                                case "denied":
                                    console.error(
                                        "Notifications were denied. Track change notifications will be disabled. To reactivate, first accept notifications, then re-enable the track change notifications from the about panel."
                                    );
                                    localStorage.setItem(
                                        "trackChangeNotifications",
                                        "false"
                                    );
                                    break;
                            }
                        }

                        this.trackName = state.item.name;
                    }
                })
                .catch((error) => {
                    try {
                        let json = JSON.parse(error.response);
                        if (json.status === 401) {
                            this.getNewTokens();
                        }
                    } catch {
                        console.error(error);
                    }
                });
        },
        getNewTokens(): void {
            let d = new Date();
            if (
                this.$store.state.refreshToken !== "" &&
                new Date().getTime() - this.$store.state.expirationStart >
                    (this.$store.state.expiresIn - 100) * 1000
            ) {
                console.log(
                    `[${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}.${d.getMilliseconds()}] Retrieving new tokens...`
                );

                let tokenParameters = new URLSearchParams({
                    grant_type: "refresh_token",
                    refresh_token: this.$store.state.refreshToken,
                });

                fetch(`https://accounts.spotify.com/api/token`, {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${btoa(
                            spotifyCredentials.clientId +
                                ":" +
                                spotifyCredentials.clientSecret
                        )}`,
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: tokenParameters,
                })
                    .then((response) => response.json())
                    .then((json) => this.storeSpotifyTokens(json))
                    .catch((error) => {
                        if (error.response) {
                            console.error(
                                error.response.data.error_description
                            );
                        } else {
                            console.error(error);
                        }
                    });
            }
        },
        storeSpotifyTokens(response: SpotifyRefreshTokenResponse): void {
            this.$store.dispatch(StoreActions.UPDATE_TOKENS, {
                accessToken: response.access_token,
                expiresIn: response.expires_in,
            });

            spotify.setAccessToken(response.access_token);
        },
        convertMillisecondsToMinSec(milliseconds: number): string {
            let ms = new Date(milliseconds),
                seconds =
                    ms.getUTCSeconds() < 10
                        ? `0${ms.getUTCSeconds()}`
                        : ms.getUTCSeconds();

            return ms.getUTCMinutes() + ":" + seconds;
        },
        refresh(): void {
            this.getCurrentPlayback();

            if (
                new Date().getTime() - this.$store.state.expirationStart >
                (this.$store.state.expiresIn - 100) * 1000
            ) {
                this.getNewTokens();
            }
        },
    },
});
